import { createMixin } from '.';

const useIntersectionObserver = (controller) => {
  const observers = [];

  controller.createIntersectionObserver = (callback, options) => {
    const observer = new IntersectionObserver(callback, options);
    observers.push(observer);
    return observer;
  };

  const disconnect = () => {
    for (const observer of observers) {
      observer.disconnect();
    }
    observers.length = 0;
  };

  return disconnect;
};

/**
 * Allows to create IntersectionObservers with automatic cleanup.
 * Meaning that you don't need to manually disconnect observers in disconnect() method.
 * @example Usage
 *   class MyController extends Controller {
 *     connect() {
 *       useIntersectionObserver(this);
 *       const observer = this.createIntersectionObserver(
 *         (entries) => entries.forEach((entry) => console.log(entry)),
 *         { threshold: 0.5 }
 *       );
 *       observer.observe(this.element);
 *     }
 *   }
 *
 * @param {Object} controller
 * @return {void}
 */
export default createMixin(useIntersectionObserver);
